module.exports = __webpack_public_path__ + "img/momiji inubashiri_sc1.0df08b33.png";